// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileNavigation_wrapper__aRR5q","mob-nav-socials":"MobileNavigation_mob-nav-socials__-+FTN","title":"MobileNavigation_title__BSrG+"};